import { render, staticRenderFns } from "./shenHolidayDetail.vue?vue&type=template&id=c073d702&"
import script from "./shenHolidayDetail.vue?vue&type=script&lang=js&"
export * from "./shenHolidayDetail.vue?vue&type=script&lang=js&"
import style0 from "./shenHolidayDetail.vue?vue&type=style&index=0&id=c073d702&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports